export default {};



// WEBPACK FOOTER //
// ./src/components/orientation-info/orientation-info.js